import React, { useEffect } from 'react'
import SectionHeader from '../../components/SectionHeader'

function Wishlist() {
  useEffect(() => {
    document.title = "Wishlist";
 }, []);
  return (
    <>
        <div className=" sectionWrapper cart-wrapper">
          <div className="container mt-2 mb-5">
            {/* {cartItems.cartResponseWOList && cartItems.cartResponseWOList.length === 0 ? ( */}
            {/* {cartItems && cartItems.length === 0 && !loading ? ( */}
              <>
                <div className="col-md-6">
                  <SectionHeader className="">
                    <span className="subtitle">Wishlist</span>
                    <h2 className="title">
                      Your <span>Wishlist</span>{" "}
                    </h2>
                  </SectionHeader>
                </div>
                <div className="d-flex justify-content-center align-items-center vh-50 mb-6">
                  <div className="text-center">
                    <p className="display-6 fw-bold">No item in Wishlist</p>
                  </div>
                </div>
              </>
          </div>
        </div>
      </>
  )
}

export default Wishlist